export default __webpack_public_path__ + "static/media/Group 19.ad0b594a.svg";